import React, { useState, useCallback } from "react"
import { Field, FieldProps } from "react-final-form"

import { ParagraphSmall } from "components/text"
import { TextButtonSmall } from "components/buttons"
import { DefaultField, DefaultFieldProps, getValidator } from "components/form"
import Select, { AsyncSelectProps } from "./async-select"
import { MenuList, ValueContainer } from "./custom-react-select-components"
import { useGooglePlaces } from "./google-services"

interface AddressWrapperProps {
  onChange: (arg: any) => void
  placeholder?: string
  value: string
  disabled?: boolean
  error?: string
}

const AddressSelectWrapper: React.FC<AddressWrapperProps> = ({ error, placeholder, onChange }) => {
  const [isDisabled, setIsDisabled] = useState(false)

  const onOptionSelected: AsyncSelectProps["onChange"] = option => {
    onChange(option)
    setIsDisabled(true)
  }

  const { loadSuggestions } = useGooglePlaces()

  return (
    <>
      <Select
        placeholderFontSize={14}
        onChange={onOptionSelected}
        placeholder={placeholder}
        loadOptions={loadSuggestions}
        components={{ MenuList, ValueContainer }}
        disabled={isDisabled}
        isSearchable={!isDisabled}
        error={error}
      />
      {isDisabled && (
        <ParagraphSmall color="evergreen" bg="paleGrey" pt={2}>
          Any prescriptions your doctor writes will be sent to this location. If this is incorrect,{" "}
          <TextButtonSmall onClick={() => setIsDisabled(false)}>change it.</TextButtonSmall>
        </ParagraphSmall>
      )}
    </>
  )
}

export const AddressInputField: React.FC<FieldProps<string, HTMLSelectElement>> = ({
  validate: validateProp = () => null,
  ...props
}) => {
  const validate = getValidator(validateProp, props.required)
  const [error, setError] = useState<boolean>(false)

  const handleSetError = useCallback(() => setError(true), [])

  return (
    <Field
      InputComponent={AddressSelectWrapper}
      parse={option => option.value}
      px={0}
      py={0}
      {...props}
      validate={validate}
      data-test={props.dataTest}
    >
      {(inputProps: DefaultFieldProps<string>) => (
        <DefaultField {...inputProps} handleSetError={handleSetError} error={error} border="none !important" />
      )}
    </Field>
  )
}
